module.exports = __webpack_public_path__ + "img/scroll-bg-2.a2a6f3f1.png";